<template>
  <div id="SignReceipt_PrintTemplate">
    <section class="logo-area">
      <img src="@/assets/img/print/LOGONAME.png" class="logo"/>

      <div class="logo-title">安家寶專案給付明細表</div>
    </section>

    <section class="info-area">
      <table cellspacing="0">
        <tr>
          <td align="center" bgcolor="#BEBEBE" class="text-weight-bold">會員姓名</td>
          <td align="center" bgcolor="#BEBEBE" class="text-weight-bold">生效日期</td>
          <td align="center" bgcolor="#BEBEBE" class="text-weight-bold">身故日期</td>
          <td align="center" bgcolor="#BEBEBE" class="text-weight-bold">會員編號</td>
        </tr>

        <tr>
          <td align="center">{{ data.member_name }}</td>
          <td align="center">{{ convertRocDate(data.join_date) }}</td>
          <td align="center">{{ convertRocDate(data.dead_at) }}</td>
          <td align="center">{{ data.number }}</td>
        </tr>

        <tr>
          <td align="center" bgcolor="#BEBEBE" class="text-weight-bold">最後繳月費日期</td>
          <td align="center" bgcolor="#BEBEBE" class="text-weight-bold">年資</td>
          <td align="center" bgcolor="#BEBEBE" class="text-weight-bold">未繳金額</td>
          <td align="center" bgcolor="#BEBEBE" class="text-weight-bold">發放日期</td>
        </tr>

        <tr>
          <td align="center">{{ convertRocDate(data.last_payment_at, false) }}</td>
          <td align="center">{{ data.claim_seniority ? `${data.claim_seniority}(個)月` : '' }}</td>
          <td align="center">{{ data.total_1_claim }}</td>
          <td align="center">{{ convertRocDate(data.pay_at, false) }}</td>
        </tr>

         <tr>
          <td align="center" bgcolor="#BEBEBE" class="text-weight-bold">受款人姓名</td>
          <td align="center" bgcolor="#BEBEBE" class="text-weight-bold">受款人身分證</td>
          <td align="center" bgcolor="#BEBEBE" class="text-weight-bold">停效日期</td>
          <td align="center" bgcolor="#BEBEBE" class="text-weight-bold">受理日期</td>
        </tr>

        <tr>
          <td align="center">{{ data.beneficiary_name }}</td>
          <td align="center">{{ data.beneficiary_ID_number }}</td>
          <td align="center">
            <template v-if="data.stop_history">
              <div v-for="(item, index) of data.stop_history.split(',')" :key="index">
                {{ convertRocDate(item.split('~')[0], false, true).year }}-{{ convertRocDate(item.split('~')[0], false, true).month }} ~
                {{ convertRocDate(item.split('~')[1], false, true).year }}-{{ convertRocDate(item.split('~')[1], false, true).month }}
              </div>
            </template>

            <!-- <template v-if="data.stop_history && data.stop_history.includes(',')">
              <div
                v-for="(item, index) of data.stop_history.split(',')"
                :key="index"
              >
                {{ convertRocDate(item.split('~')[0]) }} ~ {{ convertRocDate(item.split('~')[1]) }}
              </div>
            </template>

            <template v-else-if="data.stop_history">
              <div>
                {{ convertRocDate(data.stop_history.split('~')[0]) }} ~ {{ convertRocDate(data.stop_history.split('~')[1]) }}
              </div>
            </template> -->
          </td>
          <td align="center">{{ convertRocDate(data.accept_at) }}</td>
        </tr>
      </table>
    </section>

    <section class="info-area">
      <table cellspacing="0">
        <tr v-if="data.claim_condolence !== 0">
          <!-- 慰問基金 -->
          <td width="34%" align="left" bgcolor="#ACD6FF" class="text-weight-bold">(A)互助金理賠金額</td>
          <td align="center">{{ data.claim_condolence }}</td>
          <td align="center"></td>
        </tr>

        <tr v-if="data.pay_total !== 0">
          <!-- 已繳月費 -->
          <td align="left" class="text-weight-bold">(B)互助金已繳月費</td>
          <td align="center">{{ data.pay_total }}</td>
          <td align="center"></td>
        </tr>

        <tr v-if="data.claim_un_condolence !== 0">
          <td align="left" class="text-weight-bold">
            <template v-if="data.claim_style === 'A'">
              (C)慰問金
            </template>

            <template v-else-if="data.claim_style === 'B'">
              (C)慰問金=(B)*{{ data.claim_condolence_rate * 100 }}%
            </template>

            <template v-else-if="data.claim_style === 'C'">
              (C)慰問金=(A)-(B)
            </template>
          </td>
          <td align="center">{{ data.claim_un_condolence }}</td>
          <td align="center"></td>
        </tr>

        <tr v-if="data.claim_stable !== 0 && data.claim_style === 'C'">
          <td align="left" class="text-weight-bold">(D)安定基金=(C)*{{ data.claim_stable_rate * 100 }}%</td>
          <td align="center">{{ data.claim_stable }}</td>
          <td align="center"></td>
        </tr>

        <tr v-if="data.claim_administrative !== 0 && data.claim_style === 'C'">
          <td align="left" class="text-weight-bold">(E)行政費=(C)*{{ data.claim_administrative_rate * 100 }}%</td>
          <td align="center">{{ data.claim_administrative }}</td>
          <td align="center"></td>
        </tr>

        <tr v-if="data.claim_need_pay !== 0 && data.claim_style === 'C'">
          <td align="left" bgcolor="#BEBEBE" class="text-weight-bold">(F)應領金額=(A)-(D)-(E)</td>
          <td align="center">{{ data.claim_need_pay }}</td>
          <td align="center"></td>
        </tr>
      </table>
    </section>

    <section class="info-area">
      <table cellspacing="0">
        <tr>
          <td width="34%" align="left" bgcolor="#ACD6FF" class="text-weight-bold">

            <template v-if="data.claim_style === 'A'">
              (D)應扣除金額合計
            </template>

            <template v-else-if="data.claim_style === 'B'">
              (D)應扣除金額合計
            </template>

            <template v-else-if="data.claim_style === 'C'">
              (G)應扣除金額合計
            </template>
          </td>
          <td align="center">{{ data.claim_reduce_sum }}</td>
          <td align="center"></td>
        </tr>

        <template v-for="(item, index) in countFields">
          <tr :key="index" v-if="item.show">
            <td align="left" :bgcolor="item.headBgcolor" class="text-weight-bold">{{ item.name }}</td>
            <td align="center">{{ item.value }}</td>
            <td align="center">{{ item.remark }}</td>
          </tr>
        </template>

        <!-- <tr>
          <td align="left" bgcolor="#BEBEBE" class="text-weight-bold">未繳款項</td>
          <td align="center">{{ data.claim_unpay }}</td>
        </tr>

        <tr>
          <td align="left" bgcolor="#BEBEBE" class="text-weight-bold">自訂加錢金額</td>
          <td align="center">{{ data.claim_other_add }}</td>
        </tr>

        <tr>
          <td align="left" bgcolor="#BEBEBE" class="text-weight-bold">自訂扣款金額</td>
          <td align="center">{{ data.claim_other_reduce }}</td>
        </tr>

        <tr>
          <td align="left" bgcolor="#BEBEBE" class="text-weight-bold">年費</td>
          <td align="center">{{ data.claim_year }}</td>
        </tr>

        <tr>
          <td align="left" bgcolor="#BEBEBE" class="text-weight-bold">遞延金額</td>
          <td align="center">{{ data.claim_defferred }}</td>
        </tr>

        <tr>
          <td align="left" bgcolor="#BEBEBE" class="text-weight-bold">預領金額</td>
          <td align="center">{{ data.claim_cash_advance }}</td>
        </tr>

        <tr>
          <td align="left" bgcolor="#BEBEBE" class="text-weight-bold">預領手續費</td>
          <td align="center">{{ data.claim_cash_advance_fee }}</td>
        </tr>

        <tr>
          <td align="left" bgcolor="#BEBEBE" class="text-weight-bold">墊繳金額</td>
          <td align="center">{{ data.claim_behalf }}</td>
        </tr>

        <tr>
          <td align="left" bgcolor="#BEBEBE" class="text-weight-bold">墊繳手續費</td>
          <td align="center">{{ data.claim_behalf_fee }}</td>
        </tr> -->

        <tr>
          <td align="left" bgcolor="#ACD6FF" class="text-weight-bold">
            <template v-if="data.claim_style === 'A'">
              實領金額=(A)-(D)
            </template>

            <template v-else-if="data.claim_style === 'B'">
              實領金額=(A)-(D)
            </template>

            <template v-else-if="data.claim_style === 'C'">
              實領金額=(F)-(G)
            </template>
          </td>
          <td align="center">{{ data.claim_pay }}</td>
          <td align="center"></td>
          <!-- <td align="center">日期： 年 月 日</td>
          <td align="center">日期： 年 月 日</td> -->
        </tr>

        <tr v-if="data.claim_remark">
          <td colspan="3" bgcolor="#BEBEBE">{{ data.claim_remark }}</td>
        </tr>
      </table>
    </section>

    <section class="info-area">
      <table cellspacing="0">
        <tr>
          <td align="center" bgcolor="#BEBEBE" class="text-weight-bold">具領人簽名：</td>
          <td align="center" bgcolor="#BEBEBE" class="text-weight-bold">業務員簽名：</td>
        </tr>

        <tr>
          <td rowspan="2"></td>
          <td rowspan="2"></td>
        </tr>

        <tr></tr>

        <tr>
          <td align="center">日期：　　年　　月　　日</td>
          <td align="center">日期：　　年　　月　　日</td>
        </tr>
      </table>
    </section>
  </div>
</template>

<script>
import { convertRocDate } from "@/models/HELPERS/common.js";

export default {
  name: 'PaymentSchedule',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    data: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  watch: {
    'data.id': {
      handler(newValue, oldValue) {

      },
      immediate: false
    }
  },
  data () {
    return {
      policy: [
        {
          start: '2016-01-01',
          end: '2018-01-14',
          text: '2016-01-01 ~ 2018-01-14'
        },
        {
          start: '2018-01-15',
          end: '2020-12-31',
          text: '2018-01-15 ~ 2020-12-31'
        },
        {
          start: '2021-01-01',
          end: '2022-12-31',
          text: '2021-01-01 ~ 2022-12-31'
        },
        {
          start: '2023-01-01',
          end: new Date(),
          text: '2016-01-01 ~'
        }
      ]
    }
  },
  computed: {
    // 應領金額
    amountDue() {
      const { claim_condolence, claim_stable, claim_administrative } = this.data;

      return Number(claim_condolence) - Number(claim_stable) - Number(claim_administrative);
    },
    // 應扣除金額合計
    amountDeducted() {
      // 自訂加錢金額 是 加項，其他都是減項
      const { claim_other_add, claim_other_reduce, claim_behalf, claim_behalf_fee, claim_cash_advance, claim_cash_advance_fee, claim_stable, claim_administrative, claim_year, claim_defferred, claim_unpay } = this.data;

      return  Math.abs(Number(claim_other_add) -
            Number(claim_other_reduce) -
            Number(claim_behalf) -
            Number(claim_behalf_fee) -
            Number(claim_cash_advance) -
            Number(claim_cash_advance_fee) -
            Number(claim_stable) -
            Number(claim_administrative) -
            Number(claim_year) -
            Number(claim_defferred) -
            Number(claim_unpay));
    },
    countFields() {
      const data = [
        {
          value: this.data.claim_unpay,
          remark: this.data.claim_unpay_remark,
          name: '當期應繳帳單', // 未繳款項
          show: false,
          headBgcolor: '#FFF'
        },
        {
          value: this.data.claim_other_add,
          remark: '',
          name: this.data.claim_other_add_name ? this.data.claim_other_add_name : '自訂加錢金額',
          show: false,
          headBgcolor: '#FFF'
        },
        {
          value: this.data.claim_other_reduce,
          remark: '',
          name:  this.data.claim_other_reduce_name ? this.data.claim_other_reduce_name : '自訂扣款金額',
          show: false,
          headBgcolor: '#FFF'
        },
        {
          value: this.data.claim_year,
          remark: '',
          name: '年費',
          show: false,
          headBgcolor: '#FFF'
        },
        {
          value: this.data.claim_defferred,
          remark: `${this.data.claim_defferred_count}人 * ${this.data.fee}`,
          name: '遞延互助費', // 遞延金額
          show: false,
          headBgcolor: '#FFF'
        },
        {
          value: this.data.claim_cash_advance,
          remark: '',
          name: '預領金額',
          show: false,
          headBgcolor: '#FFF'
        },
        {
          value: this.data.claim_cash_advance_fee,
          remark: '',
          name: '預領手續費',
          show: false,
          headBgcolor: '#FFF'
        },
        {
          value: this.data.claim_behalf,
          remark: '',
          name: '墊繳金額',
          show: false,
          headBgcolor: '#FFF'
        },
        {
          value: this.data.claim_behalf_fee,
          remark: '',
          name: '墊繳手續費',
          show: false,
          headBgcolor: '#FFF'
        }
      ];

      return data.map(item => {
        return {
          ...item,
          show: item.value !== 0 && item.value !== null
        }
      })
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {

    },
    convertRocDate,
  }
}
</script>

<style lang="scss" scoped>
* {
  font-family: DFKai-sb;
}

#SignReceipt_PrintTemplate {
  width: 560px;
  height: 794px;
  .logo-area {
    display: grid;
    grid-template-columns: 1fr 1fr;
    row-gap: 5px;
    margin-bottom: 30px;
    .logo {
      height: 70px;
      width: 280px;
    }
    .logo-title {
      font-size: 26px;
      font-weight: bold;
      margin: auto 0 0 20px;
    }
  }
  .info-area {
    &:not(:last-child) {
      margin-bottom: 30px;
    }
    table {
      width: 100%;
      table-layout: fixed;
      word-wrap: break-word;
      word-break: normal;
      font-size: 16px;
      line-height: 1;
      border: 1px solid #000000;
      tr {
        height: 30px;
        td {
          border: 1px solid #000000;
          &.text-weight-bold {
            font-weight: bold;
          }
          .sign {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            row-gap: 60px;
            padding: 30px;
          }
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/common/PrintTemplate/PaymentSchedule.vue